import { useEffect, useState } from "react";
import LavorisService from "../../services/LavorisService";
import { getProfileResponseService } from "../../services/Company/Company.type"
import StyledWrapper from "./style";
import { PhoneNumber } from "../../utils/phoneNumber";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";


const DatosSucursal = () => {
  const LavorisInstance = LavorisService.getInstance();
  // useStates
  const [data, setData] = useState<getProfileResponseService>();
  const chosenCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]);
  const [emails, setEmails] = useState<any>()

  // useEffects
  useEffect(() => {
    const getCompanyProfile = async () => {
      try {
        const companyProfile = await LavorisInstance.CompanyServices.getOneCompany(chosenCompany.id);
        if (companyProfile) {
          setData(companyProfile);
          const compEmails = await LavorisInstance.CompanyServices.getCompanyEmails(companyProfile?.managerId || "")
          setEmails(compEmails)
        }
      } catch (e) {
        console.log(e);
      }
    };
    getCompanyProfile();
  }, []);


  const aliasFormatter = (alias: string | undefined) => {
    if (alias) {
      const formattedAlias = alias.split("_").join(" ").toLocaleLowerCase();
      return formattedAlias
    }
    return "N/A"
  }

  return (
    <>
      <StyledWrapper.DatosContainer>
        {/**DATOS DE LA EMPRESA */}
        <StyledWrapper.PersonalInfoGrouping>
          <StyledWrapper.InfoGrouping>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.RowTitle> Datos de la empresa</StyledWrapper.RowTitle>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Razón social</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.socialReason || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>CUIT</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.cuit || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Rubro de la empresa</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.heading || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Nombre de Fantasía</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.branchOfficeName || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Condición frente al IVA</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.ivaCondition || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>ART</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                <span className="capitalize">{aliasFormatter(data?.ART)}</span>
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

          </StyledWrapper.InfoGrouping>
        </StyledWrapper.PersonalInfoGrouping>

        {/**DATOS DE CONTACTO EMPRESA - BRANCH */}
        <StyledWrapper.PersonalInfoGrouping>
          <StyledWrapper.InfoGrouping>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.RowTitle> Datos de contacto</StyledWrapper.RowTitle>
            </StyledWrapper.IndividualInfo>


            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Provincia</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.province || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>


            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Ciudad</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.location || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Dirección</StyledWrapper.Header>
              <StyledWrapper.SubHeader>{data?.residence}</StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Código Postal</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.postalCode || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Teléfono</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {(data?.phoneNumber && PhoneNumber(data?.phoneNumber)) || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.Header>Email</StyledWrapper.Header>
              <StyledWrapper.SubHeader>
                {data?.email || "N/A"}
              </StyledWrapper.SubHeader>
            </StyledWrapper.IndividualInfo>
          </StyledWrapper.InfoGrouping>
        </StyledWrapper.PersonalInfoGrouping>

        {/**DATOS DE FACTURACION */}
        <StyledWrapper.BillingInfoGrouping>
          <StyledWrapper.InfoGrouping>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.RowTitle> Datos de facturación</StyledWrapper.RowTitle>
            </StyledWrapper.IndividualInfo>

            <StyledWrapper.BillingColumns>
              <StyledWrapper.BillingColumn>
                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Código Cliente</StyledWrapper.Header>
                  <StyledWrapper.SubHeader>
                    {data?.managerId || "N/A"}
                  </StyledWrapper.SubHeader>
                </StyledWrapper.IndividualInfo>

                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Facturar a</StyledWrapper.Header>
                  <StyledWrapper.SubHeader>
                    {data?.billedTo || "N/A"}
                  </StyledWrapper.SubHeader>
                </StyledWrapper.IndividualInfo>

                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Emails Facturación</StyledWrapper.Header>
                  {emails?.length > 0 ? <ul>
                    {emails?.map((email: any, i: any) => <StyledWrapper.SubHeader key={i}>- {email}</StyledWrapper.SubHeader>)}
                  </ul> : '---'}
                </StyledWrapper.IndividualInfo>

                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Portal web para la carga y gestión de facturas</StyledWrapper.Header>
                  {data?.billing_web_url ? (
                    <a href={data.billing_web_url} target="_blank" rel="noopener noreferrer">
                      <StyledWrapper.SubHeader>{data.billing_web_url}</StyledWrapper.SubHeader>
                    </a>
                  ) : (
                    <StyledWrapper.SubHeader>N/A</StyledWrapper.SubHeader>
                  )}
                </StyledWrapper.IndividualInfo>

                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Necesita Orden de compra o Nota de pedido</StyledWrapper.Header>
                  <StyledWrapper.SubHeader>
                    {data?.purchase_order || "N/A"}
                  </StyledWrapper.SubHeader>
                </StyledWrapper.IndividualInfo>

                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Email de cuentas a pagar</StyledWrapper.Header>
                  {data?.account_payable_email ? (
                    <a href={`mailto:${data.account_payable_email}`}>
                      <StyledWrapper.SubHeader>{data.account_payable_email}</StyledWrapper.SubHeader>
                    </a>
                  ) : (
                    <StyledWrapper.SubHeader>N/A</StyledWrapper.SubHeader>
                  )}
                </StyledWrapper.IndividualInfo>
              </StyledWrapper.BillingColumn>

              <StyledWrapper.BillingColumn>
                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Forma de Pago</StyledWrapper.Header>
                  <StyledWrapper.SubHeader>
                    {data?.paymentMethod || "N/A"}
                  </StyledWrapper.SubHeader>
                </StyledWrapper.IndividualInfo>

                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Plazo de Pago</StyledWrapper.Header>
                  <StyledWrapper.SubHeader>
                    {data?.paymentDeadline || "N/A"}
                  </StyledWrapper.SubHeader>
                </StyledWrapper.IndividualInfo>

                <StyledWrapper.IndividualInfo>
                  <StyledWrapper.Header>Ciclo de Facturación</StyledWrapper.Header>
                  <StyledWrapper.SubHeader>
                    {data?.invoiceDate || "N/A"}
                  </StyledWrapper.SubHeader>
                </StyledWrapper.IndividualInfo>

                <div className="hidden">
                  <StyledWrapper.IndividualInfo>
                    <StyledWrapper.Header>Inicio del Ciclo</StyledWrapper.Header>
                    <StyledWrapper.SubHeader>
                      {data?.billingStartDate || "N/A"}
                    </StyledWrapper.SubHeader>
                  </StyledWrapper.IndividualInfo>
                </div>

                <div className="hidden">
                  <StyledWrapper.IndividualInfo>
                    <StyledWrapper.Header>Cantidad de Períodos</StyledWrapper.Header>
                    <StyledWrapper.SubHeader>
                      {data?.numberOfPeriods || "N/A"}
                    </StyledWrapper.SubHeader>
                  </StyledWrapper.IndividualInfo>
                </div>
              </StyledWrapper.BillingColumn>
            </StyledWrapper.BillingColumns>

          </StyledWrapper.InfoGrouping>
        </StyledWrapper.BillingInfoGrouping>


        {/* *CUENTAS DE USUARIO
        <StyledWrapper.PersonalInfoGrouping>
          <StyledWrapper.InfoGrouping>
            <StyledWrapper.IndividualInfo>
              <StyledWrapper.RowTitle> Cuentas de usuario</StyledWrapper.RowTitle>
            </StyledWrapper.IndividualInfo>
            
          </StyledWrapper.InfoGrouping>
        </StyledWrapper.PersonalInfoGrouping> */}




      </StyledWrapper.DatosContainer>
    </>
  );
};
export default DatosSucursal;
